import React, {useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import {useAuth0} from "@auth0/auth0-react";
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment";
import axios from "axios";
import "../../App.css";
import SystemContext from "../../SystemContext";
import {getApiSitePrefix} from "../../functions/SiteDefaults";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import FlightMonitorStyles from "./styles/FlightMonitorStyles";
import ReportSelectionDialog from "./components/ReportSelectionDialog";

const AccessControl = require ("../../AccessControl");
const apiSitePrefix = getApiSitePrefix();


function RampActionReport(props) {
  const SystemData = useContext(SystemContext);
  const classes = makeStyles(FlightMonitorStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Manage SLR"]);

  const history = useHistory();
  const handleClose = event => {
    SystemData.goHome(history);
  };

  const [selectAirport, setSelectAirport] = useState({
    open: true,
    airport: null,
    mode: "download"
  });

  async function downloadReport(target, filter, download = true, fromDate, toDate, airportCode = null, airportName = null) {

    if (!target)
      return;

    const startDateMoment = fromDate ? moment(fromDate) : moment().startOf("month");
    const startDate = startDateMoment.isValid() ? startDateMoment.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
    const endDateMoment = toDate? moment(toDate) : moment().endOf("month");
    const endDate = endDateMoment.isValid() ? endDateMoment.format("YYYY-MM-DD") : moment().endOf("month").format("YYYY-MM-DD");

    let url = `${apiSitePrefix}/${target}/report/${startDate}/${endDate}/${filter}`;

    if (url) {
      try {
        SystemData.toggleLoadingProgress(true, `Preparing Report ...`);
        const response = await axios.get(url, {
          headers: {
            //'Access-Control-Allow-Headers': ['Origin', 'X-Requested-With', 'Content-Type', 'Accept'],
            'Access-Control-Allow-Origin': '*',
          }
        });

        if (response && response.data) {
          if (response.data.status) {
            SystemData.toggleLoadingProgress(false);
            if (!download) {
              let templateType;
              let subject;
              let attachmentDescription;
              const displayDateFormat = "DD MMM YYYY";
              const scheduleFrom = startDateMoment.isValid() ? startDateMoment.format(displayDateFormat) : moment().format(displayDateFormat);
              const scheduleTo = moment(scheduleFrom, displayDateFormat).endOf("month").format(displayDateFormat);
              const fileName = response.data.downloadFileName;
              switch (target) {
                case "rampactions":
                  subject = `RampActions Report // ${scheduleFrom} to ${scheduleTo} ${airportCode ? `// ${airportName}` : ``}`;
                  templateType = "CUSTOMER_FLIGHTS";
                  attachmentDescription = `${subject}`;
                  break;
                default:
                  subject = `RampActions Report // ${scheduleFrom} to ${scheduleTo} ${airportCode ? `// ${airportName}` : ``}`;
                  templateType = "CUSTOMER_FLIGHTS";
                  attachmentDescription = `${subject}`;
                  break;
              }

              const emailRecord = {
                target: target,
                targetFilter: filter,
                recipients: "",
                carbonCopy: "",
                subject: subject,
                templateType: templateType,
                templateUuid: "dummyTemplateUuid",
                attachmentDescription: attachmentDescription,
                attachmentUrl: response.data.excelSignedUrl,
                fileName: fileName.replaceAll("/",""),
                repeatData: [],
                contactRole: ""
              }
              SystemData.sendEmail(emailRecord, `Send Report`, true);
              handleClose();
              return;
            }

            const fileName = response.data.downloadFileName;
            let a = document.createElement('a');
            a.href = response.data.excelSignedUrl;
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            setTimeout(() => { document.body.removeChild(a); }, 0);
            handleClose();
          } else {
            SystemData.toggleLoadingProgress(false);
            handleClose();
            SystemData.openAlert(
              "Download Error",
              `The report could not be downloaded due to the following error: ${response.data.error}`
            );
          }
        }
      } catch (err) {
        SystemData.toggleLoadingProgress(false);
        handleClose();
        SystemData.openAlert(
          "Download Error",
          `The report could not be downloaded due to the following unexpected error: ${err}`
        );
      }
    }
  }

  return (isAuthenticated &&
    <div
      className="RampActionReport"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="rampactionreport"
        pageName="Ramp Actions Report"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div
        className={classes.rooted}
        style={{ marginLeft: 40, marginRight: 40, minHeight: `calc(100vh - ${(99+2+10+57+4)}px)`, backgroundColor: "#f1f1f1"}}
      >
        <div style={{display: "flex"}}>

          <ReportSelectionDialog
            open={selectAirport.open}
            onChange={(fromDate, toDate, airportCode, airportName) => {
              if (fromDate && toDate) {
                downloadReport("rampactions", airportCode, true, fromDate, toDate, airportCode, airportName);
              } else {
                handleClose();
              }
              setSelectAirport({...selectAirport, open: false, airport: airportCode});
            }}
          />

        </div>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default RampActionReport;
